import React from 'react';
import styled, { css } from 'styled-components';

import { Grids, ColorPalettes, Breakpoints } from 'kinedu-react-components';
import { OBStepStatus } from '../../containers/ObContainer.tsx';
import { useTranslation } from 'react-i18next';
const { KineduPalette } = ColorPalettes;

const List = styled.ul`
${Grids.mobile}
  position: absolute;
  top: 0px;
  left: -355px;

  display: none;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  justify-content: space-around;

  width: 400px;
  height: 100%;
  padding: 0;
  margin: 0;

  list-style: none;
  counter-reset: bullets;
  z-index: 1;

  ${Breakpoints.desktop} {
    ${Grids.ob}
    position: absolute;
    top: 0px;
    left: -355px;

    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
    justify-content: space-around;

    width: 400px;
    height: 100%;
    padding: 0;
    margin: 0;

    list-style: none;
    counter-reset: bullets;
    z-index: 1;
    }


`;

const Label = styled.li`
  display: flex;
  align-items: center;
  flex-shrink: 0;

  float: right;
  text-align: right;

  cursor: pointer;
`;

const LabelText = styled.span`
  width: auto;
  margin-left: 20px;

  font-weight: 500;
  font-size: 20px;
  text-transform: uppercase;
  transition: 0.5s all ease;

  ${({ status }) => {
    switch (status) {
      case OBStepStatus.DOING: return css`
        color: white;
      `;
      case OBStepStatus.DONE: return css`
        color: white;
        opacity: 0.5;
      `;
      default: return css`
        color: ${KineduPalette.newKinedu};
      `;
    }
  }};
`;

const Bullet = styled.div`
    position: relative;
    margin: auto 20px;

    display: flex;
    box-sizing: border-box;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;

    width: 48.6px;
    height: 48.6px;
    border-radius: 100%;
    transition: 0.5s all ease;

    ${({ active }) => (active
    ? css`
      background-color: ${KineduPalette.physical};
      box-shadow: 7px 7px 20px -5px ${KineduPalette.physical};
    `
    : css`
      background-color: ${KineduPalette.physicalLight70};
    `)};

    color: white;
    font-size: 20px;
    font-weight: bold;

    &::before {
      counter-increment: bullets;
      content: counter(bullets);
    }
`;

const StepLabels = ({ items = [], goToStep }) => {
  const { t } = useTranslation();
  return (
    <List>
      {
          items.map((item, index) => {
            const isActive = item.status === OBStepStatus.DOING;
            return (
              <Label key={item.label} onClick={() => (item.status === OBStepStatus.DONE ? goToStep(index) : {})}>
                <LabelText status={item.status}>{t(`ob:${item.label}`)}</LabelText>
                <Bullet active={isActive} />
              </Label>
            );
          })
        }
    </List>
)};

export default StepLabels;
